export * from './middleBanner.variants.defaults';
